import React from 'react';
import AppHomeForm from './form';
import {getAppHomeSetting, updateAppHomeSetting} from './../../../modules/Api';
import {normalizer} from './pipeline';
import {notification} from 'antd';
import history from './../../../modules/History';

import './custom.css';

class AppIndex extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
        }
        
    }
    componentDidMount() {
        this.fetchCouponDetail();
    }
    fetchCouponDetail() {
        getAppHomeSetting(response => {this.setState({data: response})});
    }
    
    submit(values) {
        const formData = normalizer(values, this.state.data);
        updateAppHomeSetting(formData, () => {
            notification.open({
                message: `تنظیمات با موفقیت ویرایش شد!`,
                description: ``
            });
            history.item.push(`/app-home`);
        })
    }
    render() {
        return (<div><AppHomeForm initialData={this.state.data} submit={this.submit.bind(this)}/></div>);
    }
}

export default AppIndex;


// WEBPACK FOOTER //
// ./src/containers/Application/Home/index.js